export { default } from './InternetForm.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Internet/InternetForm/index.js